<div class="tooltip-widget-wrapper pointer-events-none">
  <finxone-platform-tooltip
    [content]="renderedTemplate"
    [textStyleClass]="tooltipTextStyleClass"
    [borderRadiusClass]="tooltipBorderRadiusClass"
    [infoIconStyles]="iconStyles"
    [tooltipIcon]="icon"
  ></finxone-platform-tooltip>
</div>
